export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-[14px] text-foreground-500 mb-8">
            有任何建议、合作意向或投稿需求，欢迎通过以下方式与我们取得联系
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-6 py-4 border border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <div className="text-left">
                <p className="text-[12px] text-foreground-400">商务合作</p>
                <p className="text-[14px] font-semibold text-foreground-800">contact@xinxinmanga.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-6 py-4 border border-background-200/70">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-accent-500 text-lg"></i>
              </div>
              <div className="text-left">
                <p className="text-[12px] text-foreground-400">投稿 / 建议</p>
                <p className="text-[14px] font-semibold text-foreground-800">feedback@xinxinmanga.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}